import {
  DEFAULT_AWS_REGION,
  REGION_CONFIGS,
} from "shell/platform/constants/constants";

import type { AWSRegion } from "./types";

const REGION_KEY = "selectedAWSRegion";

export const getCurrentRegion = (): AWSRegion => {
  if (
    typeof localStorage === "undefined" ||
    typeof localStorage.getItem !== "function"
  ) {
    return DEFAULT_AWS_REGION;
  }
  const stored = localStorage.getItem(REGION_KEY);
  if (stored && stored in REGION_CONFIGS) {
    return stored as AWSRegion;
  }
  return DEFAULT_AWS_REGION;
};

export const setCurrentRegion = (region: AWSRegion): void => {
  if (
    typeof localStorage !== "undefined" &&
    typeof localStorage.setItem === "function"
  ) {
    localStorage.setItem(REGION_KEY, region);
  }
};

export const withRegion = async <T>(
  region: AWSRegion,
  fn: () => Promise<T>,
): Promise<T> => {
  const previousRaw =
    typeof localStorage !== "undefined" &&
    typeof localStorage.getItem === "function"
      ? localStorage.getItem(REGION_KEY)
      : null;

  setCurrentRegion(region);
  try {
    return await fn();
  } finally {
    if (previousRaw !== null && previousRaw in REGION_CONFIGS) {
      setCurrentRegion(previousRaw as AWSRegion);
    } else if (
      typeof localStorage !== "undefined" &&
      typeof localStorage.removeItem === "function"
    ) {
      localStorage.removeItem(REGION_KEY);
    }
  }
};

export const getRegionOptions = () => {
  return Object.entries(REGION_CONFIGS).map(([key, config]) => ({
    value: key as AWSRegion,
    label: config.name,
    awsRegion: config.awsRegion,
  }));
};
